<div class="chatbot" [class.has-footer]="hasFooter">
  <div class="start-chat" [class.hidden]="opened">
    <button class="w-full h-full text-left flex items-center gap-1"
      (click)="onChangeChatBoxState(true)">
      <mat-icon svgIcon="heroicons_outline:chat-round"
        class="text-white">
      </mat-icon>
      {{ 'CHATBOT.START_CHAT' | transloco }}
    </button>
  </div>

  <div class="chat-box" [class.opened]="opened">
    <div class="chat-box__header">
      <div class="flex items-center gap-2">
        <mat-icon svgIcon="heroicons_outline:chat-round" class="text-white"></mat-icon>

        {{ 'CHATBOT.TITLE' | transloco }}
      </div>

      @if (isTestInUsed$ | async) {
        <div class="test-badge">
          {{ 'CHATBOT.TEST_MODE' | transloco }}
        </div>
      }

      <button mat-icon-button (click)="onChangeChatBoxState(false)">
        <mat-icon class="text-white">close</mat-icon>
      </button>
    </div>

    <div class="chat-box__body">
      <div class="chat-box__body-content" #content
        [class.has-reset-button]="resetButtonVisible">
        @if (isEmpty$ | async) {
          @if (isTestInUsed$ | async) {
            <div class="reset-chat">
              <button mat-stroked-button (click)="onStopTestingChatbot()">
                {{ 'CHATBOT.STOP_TEST_CHATBOT' | transloco }}
              </button>
            </div>
          }
          <app-chat-onboarding class="w-full"/>
        } @else {
          @for (message of messages$ | async; track identify($index, message)) {
            <chat-message
              [class.mine]="!message.isResponse"
              [message]="message"
              (keepScrollDown)="onScrollDown($event)">
            </chat-message>
          }
          @if (loading$ | async) {
            <chat-message [isPlaceholder]="true"></chat-message>
          }
          @if (resetButtonVisible) {
            <div class="reset-chat">
              <button mat-button (click)="onResetChat()">
                {{ 'CHATBOT.RESET_CHAT' | transloco }}
              </button>
              @if (resetButtonVisible && isTestInUsed$ | async) {
                <button
                  mat-stroked-button (click)="onStopTestingChatbot()">
                  {{ 'CHATBOT.STOP_TEST_CHATBOT' | transloco }}
                </button>
              }
            </div>
          }
        }
      </div>
      <chat-input (send)="onSendMessage($event)"></chat-input>
    </div>
  </div>
</div>

